window.createUrl = function (route, lang) {
  if (!lang) {
    lang = window.lang;
  }

  if (lang === 'ach') {
    return '/ach' + window.routes.en[route];
  }

  return window.routes[lang][route];
};
window.routes = {
  en: {
    homepage: '/',
    search_la: '/s/liveaboards/:slug/',
    fleets: '/fleets/:slug/',
    search_dr: '/s/dive-resorts/:slug/',
    checkout_la: '/checkout/liveaboard/:location/:slug/',
    checkout_dr: '/checkout/dive-resort/:location/:slug/',
    login: '/login/',
    reset_password: '/account/password/reset/:uid/:token/',
    wizard: '/wizard/',
    wishlist: '/wishlist/',
    itinerary: '/liveaboard/:location/:slug/:itinerarySlug/',
    bookings: '/bookings/',
    aff_bookings: '/aff-bookings/',
    booking_info: '/bookings/:id/',
    coupons: '/payment-and-coupons/',
    settings: '/settings/',
    profile: '/profile/',
    preferences: '/preferences/',
    recently_viewed: '/recently-viewed/',
    register_activate: '/register/activate/',
    register_completed: '/register/completed/',
    account_activation: '/account/activation/:key/',
    la_deals: '/liveaboard-deals/',
    dr_deals: '/dive-resort-deals/',
    last_minute_deals: '/last-minute-deals/',
    group_bookings: '/group-bookings/',
    change_card: '/change-card/:uuid/',
    confirm_booking: '/confirm-booking/:uuid/',
    la_page: '/liveaboard/:location/:slug/',
    dr_page: '/dive-resort/:location/:slug/',
    destination: '/d/:location/',
    destinations: '/destinations/',
    liveaboard_diving_location: '/liveaboard-diving/:location/',
    why_book_with_us: '/why-book-with-us/',
    faq: '/faq/',
    terms: '/terms/',
    terms_dc: '/terms/dive-center/',
    imprint: '/imprint/',
    privacy: '/privacy/',
    best_price_guarantee: '/best-price-guarantee/',
    liveaboard_diving: '/liveaboard-diving/',
    marketplace_search: '/s/group-trips/:slug/',
  },
  fr: {
    homepage: '/fr/',
    search_la: '/fr/s/croisieres-plongee/:slug/',
    fleets: '/fr/flottes/:slug/',
    search_dr: '/fr/s/resorts-plongee/:slug/',
    checkout_la: '/fr/checkout/croisiere-plongee/:location/:slug/',
    checkout_dr: '/fr/checkout/resort-plongee/:location/:slug/',
    login: '/fr/login/',
    reset_password: '/fr/compte/mot-de-passe/reinitialisation/:uid/:token/',
    wizard: '/fr/outil/',
    wishlist: '/fr/wishlist/',
    itinerary: '/fr/croisiere-plongee/:location/:slug/:itinerarySlug/',
    bookings: '/fr/reservations/',
    aff_bookings: '/fr/aff-reservations/',
    booking_info: '/fr/reservations/:id/',
    coupons: '/fr/paiement-et-codes-reduction/',
    settings: '/fr/parametres/',
    profile: '/fr/profil/',
    preferences: '/fr/preferences/',
    recently_viewed: '/fr/consultes-recemment/',
    register_activate: '/fr/inscription/activer/',
    register_completed: '/fr/inscription/termine/',
    account_activation: '/fr/compte/activation/:key/',
    la_deals: '/fr/croisiere-plongee-offres/',
    dr_deals: '/fr/sejour-plongee-offres/',
    last_minute_deals: '/fr/offres-dernières-minutes/',
    group_bookings: '/fr/reservations-groupe/',
    change_card: '/fr/changer-carte/:uuid/',
    confirm_booking: '/fr/confirmer-reservation/:uuid/',
    la_page: '/fr/croisiere-plongee/:location/:slug/',
    dr_page: '/fr/resort-plongee/:location/:slug/',
    destination: '/fr/d/:location/',
    destinations: '/fr/destinations/',
    liveaboard_diving_location: '/fr/croisiere-plonger/:location/',
    why_book_with_us: '/fr/pourquoi-reserver-avec-nous/',
    faq: '/fr/faq/',
    terms: '/fr/conditions/',
    terms_dc: '/fr/conditions/centre-plongee/',
    imprint: '/fr/impressum/',
    privacy: '/fr/confidentialite/',
    best_price_guarantee: '/fr/garantie-meilleur-prix/',
    liveaboard_diving: '/fr/croisiere-plonger/',
    marketplace_search: '/fr/s/voyages-en-groupe/:slug/',
  },
  es: {
    homepage: '/es/',
    search_la: '/es/s/cruceros-de-buceo/:slug/',
    fleets: '/es/flotas/:slug/',
    search_dr: '/es/s/resorts-de-buceo/:slug/',
    checkout_la: '/es/proceso-de-compra/crucero-de-buceo/:location/:slug/',
    checkout_dr: '/es/proceso-de-compra/resort-de-buceo/:location/:slug/',
    login: '/es/iniciar-sesion/',
    reset_password: '/es/cuenta/contraseña/restablecer/:uid/:token/',
    wizard: '/es/asistente-online/',
    wishlist: '/es/lista-de-favoritos/',
    itinerary: '/es/crucero-de-buceo/:location/:slug/:itinerarySlug/',
    bookings: '/es/reservas/',
    aff_bookings: '/es/aff-reservas/',
    booking_info: '/es/reservas/:id/',
    coupons: '/es/pago-y-cupones/',
    settings: '/es/ajustes/',
    profile: '/es/perfil/',
    preferences: '/es/preferencias/',
    recently_viewed: '/es/recien-visitados/',
    register_activate: '/es/registro/activar/',
    register_completed: '/es/registro/completado/',
    account_activation: '/es/cuenta/activacion/:key/',
    la_deals: '/es/ofertas-crucero-de-buceo/',
    dr_deals: '/es/ofertas-resort-de-buceo/',
    last_minute_deals: '/es/ofertas-ultima-hora/',
    group_bookings: '/es/reservas-grupo/',
    change_card: '/es/cambiar-tarjeta/:uuid/',
    confirm_booking: '/es/confirmar-reserva/:uuid/',
    la_page: '/es/crucero-de-buceo/:location/:slug/',
    dr_page: '/es/resort-de-buceo/:location/:slug/',
    destination: '/es/d/:location/',
    destinations: '/es/destinos/',
    liveaboard_diving_location: '/es/buceo-crucero-de-buceo/:location/',
    why_book_with_us: '/es/por-que-reservar-con-nosotros/',
    faq: '/es/faq/',
    terms: '/es/términos/',
    terms_dc: '/es/términos/centro-de-buceo/',
    imprint: '/es/pie-de-imprenta/',
    privacy: '/es/privacidad/',
    best_price_guarantee: '/es/mejor-precio-garantizado/',
    liveaboard_diving: '/es/buceo-crucero-de-buceo/',
    marketplace_search: '/es/s/viajes-en-grupo/:slug/',
  },
  de: {
    homepage: '/de/',
    search_la: '/de/s/tauchsafaris/:slug/',
    fleets: '/de/flotten/:slug/',
    search_dr: '/de/s/tauchresorts/:slug/',
    checkout_la: '/de/kasse/tauchsafari/:location/:slug/',
    checkout_dr: '/de/kasse/tauchresort/:location/:slug/',
    login: '/de/login/',
    reset_password: '/de/konto/passwort/zurücksetzen/:uid/:token/',
    wizard: '/de/assistent/',
    wishlist: '/de/wunschzettel/',
    itinerary: '/de/tauchsafari/:location/:slug/:itinerarySlug/',
    aff_bookings: '/de/aff-buchungen/',
    bookings: '/de/buchungen/',
    booking_info: '/de/buchungen/:id/',
    coupons: '/de/zahlung-und-coupons/',
    settings: '/de/einstellungen/',
    profile: '/de/profil/',
    preferences: '/de/praeferenzen/',
    recently_viewed: '/de/vor-kurzem-angesehen/',
    register_activate: '/de/registrieren/aktivieren/',
    register_completed: '/de/registrieren/abgeschlossen/',
    account_activation: '/de/konto/aktivierung/:key/',
    la_deals: '/de/tauchsafari-angebote/',
    dr_deals: '/de/tauchresort-angebote/',
    last_minute_deals: '/de/last-minute-angebote/',
    group_bookings: '/de/gruppenbuchungen/',
    change_card: '/de/karte-aendern/:uuid/',
    confirm_booking: '/de/buchung-bestätigen/:uuid/',
    la_page: '/de/tauchsafari/:location/:slug/',
    dr_page: '/de/tauchresort/:location/:slug/',
    destination: '/de/d/:location/',
    destinations: '/de/reiseziele/',
    liveaboard_diving_location: '/de/tauchsafari-tauchen/:location/',
    why_book_with_us: '/de/warum-bei-uns-buchen/',
    faq: '/de/faq/',
    terms: '/de/teilnahmebedingungen/',
    terms_dc: '/de/teilnahmebedingungen/tauchcenter/',
    imprint: '/de/impressum/',
    privacy: '/de/privatsphaere/',
    best_price_guarantee: '/de/bestpreisgarantie/',
    liveaboard_diving: '/de/tauchsafari-tauchen/',
    marketplace_search: '/de/s/gruppenreisen/:slug/',
  },
  it: {
    homepage: '/it/',
    search_la: '/it/s/crociere-sub/:slug/',
    fleets: '/it/flotte/:slug/',
    search_dr: '/it/s/viaggi-sub/:slug/',
    checkout_la: '/it/checkout/crociera-sub/:location/:slug/',
    checkout_dr: '/it/checkout/viaggio-sub/:location/:slug/',
    login: '/it/login/',
    reset_password: '/it/account/password/reimposta/:uid/:token/',
    wizard: '/it/procedura-guidata/',
    wishlist: '/it/lista-dei-desideri/',
    itinerary: '/it/crociera-sub/:location/:slug/:itinerarySlug/',
    aff_bookings: '/it/aff-prenotazioni/',
    bookings: '/it/prenotazioni/',
    booking_info: '/it/prenotazioni/:id/',
    coupons: '/it/pagamento-e-coupon/',
    settings: '/it/impostazioni/',
    profile: '/it/profilo/',
    preferences: '/it/preferenze/',
    recently_viewed: '/it/visti-recentemente/',
    register_activate: '/it/registra/attiva/',
    register_completed: '/it/registra/completato/',
    account_activation: '/it/account/attivazione/:key/',
    la_deals: '/it/offerte-crociere-sub/',
    dr_deals: '/it/offerte-viaggi-sub/',
    last_minute_deals: '/it/offerte-last-minute/',
    group_bookings: '/it/prenotazioni-gruppi/',
    change_card: '/it/modifica-carta/:uuid/',
    confirm_booking: '/it/conferma-prenotazione/:uuid/',
    la_page: '/it/crociera-sub/:location/:slug/',
    dr_page: '/it/viaggio-sub/:location/:slug/',
    destination: '/it/d/:location/',
    destinations: '/it/destinazioni/',
    liveaboard_diving_location: '/it/vacanze-crociere-sub/:location/',
    why_book_with_us: '/it/perché-prenotare-con-noi/',
    faq: '/it/faq/',
    terms: '/it/termini/',
    terms_dc: '/it/termini/dive-center/',
    imprint: '/it/imprint/',
    privacy: '/it/privacy/',
    best_price_guarantee: '/it/garanzia-miglior-prezzo/',
    liveaboard_diving: '/it/vacanze-crociere-sub/',
    marketplace_search: '/de/s/viaggi-di-gruppo/:slug/',
  },
};
